export default "__VITE_ASSET__BhVyU636__"